import { useMemo, useRef, useLayoutEffect } from 'react';
import { ScrollLock } from '../ScrollUtils';
/**
 * use scroll lock
 * @returns {React.MutableRefObject<undefined>}
 */
export const useScrollLock = () => {
    const ref = useRef();
    const scrollLock = useMemo(() => new ScrollLock(ref), [ref]);
    useLayoutEffect(() => {
        scrollLock.disable();
        return () => {
            scrollLock.enable();
        };
    }, [scrollLock]);
    return ref;
};
export default useScrollLock;
